import React from "react";
import { logAppLaunchCustom } from "@lib/fireAppLaunchCustom";
import initMovex from "@lib/initMovex";
import { initialiseSentry } from "@lib/sentry";
import codePush from "@revopush/react-native-code-push";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { codePushKey } from "@config";
import { actions } from "@reducers/configReducer";
import ErrorBoundary from "@screens/ErrorBoundary";
import { persistor, store } from "@store";
import RootComponent from "./src";
import CodePushModal from "./src/components/CodePushModal";

logAppLaunchCustom();
initialiseSentry();
initMovex();
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      progressModal: false,
    };
  }

  componentDidMount() {
    // invoke app set up .
    store.dispatch(actions.invokeAppSetup());
  }

  componentWillUnmount() {
    store.dispatch(actions.clearAppSetup());
  }

  codePushStatusDidChange(status) {
    switch (status) {
      case codePush.SyncStatus.CHECKING_FOR_UPDATE:
        break;
      case codePush.SyncStatus.DOWNLOADING_PACKAGE:
        this.setState({
          progressModal: true,
        });
        break;
      case codePush.SyncStatus.INSTALLING_UPDATE:
        break;
      case codePush.SyncStatus.UP_TO_DATE:
        this.setState({
          progressModal: false,
        });
        break;
      case codePush.SyncStatus.UPDATE_INSTALLED:
        this.setState(
          {
            progressModal: false,
          },
          () => {
            // Note: react-native-bootsplash v6 does not support show() — splash only displays on app launch.
            // The app will restart via CodePush and splash will show naturally.
            codePush.restartApp();
          },
        );
        break;
      case codePush.SyncStatus.UNKNOWN_ERROR:
        this.setState({
          progressModal: false,
        });
        break;
    }
  }

  codePushDownloadDidProgress(progress) {
    const value = progress.receivedBytes / progress.totalBytes;
    this.setState(
      {
        progress: Math.round(value * 100),
      },
      () => {
        if (this.state.progress > 98) {
          this.setState({
            progressModal: false,
          });
        }
      },
    );
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ErrorBoundary>
            <CodePushModal
              progress={this.state.progress}
              progressModal={this.state.progressModal}
            />
            <RootComponent />
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    );
  }
}

const codePushOptions = {
  updateDialog: false,
  installMode: codePush.InstallMode.IMMEDIATE,
  deploymentKey: codePushKey,
};

export default codePush(codePushOptions)(App);
